import { useState } from 'react'
import { getI18n } from 'react-i18next'
import PropTypes from 'prop-types'
import { AdjustmentsHorizontalIcon } from '@heroicons/react/24/solid'

import EstimationState from './estimation-state'
import Typo from '../../typo'
import Modal from '../../modal'
import { useIsMobile } from '../../../hooks/use-is-mobile'
import AnalyseInfoCard from '../analyse/analyse-info-card'
import EstimationText from './estimation-text'
import { useIsTouchDevice } from '../../../hooks/use-is-touch-device'
import clsx from 'clsx'

const AdjustmentsIcon = () => {
  return (
    <div className='size-8 flex justify-center items-center rounded-full'>
      <AdjustmentsHorizontalIcon className='size-5 text-orange-600' />
    </div>
  )
}

const OverviewItem = ({ dimension }) => {
  const { language } = getI18n()
  const { isMobile } = useIsMobile()
  const { isTouch } = useIsTouchDevice()

  const { estimation, category, key: dimension_key } = dimension

  const [isHovered, setIsHovered] = useState(false)
  const [displayAnalyse, setDisplayAnalyse] = useState(false)

  if (isMobile) {
    return (
      <>
        <div
          className='w-full flex flex-col mx-auto cursor-pointer'
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => setDisplayAnalyse(true)}
        >
          <div className='flex items-center h-8'>
            <Typo type='h2' underline={isTouch || isHovered}>
              {dimension.property[language]}
            </Typo>
            {(isTouch || isHovered) && <AdjustmentsIcon />}
          </div>
          <div className='h-3' />
          <EstimationState estimation={estimation} />
          <div className='h-3' />
          <EstimationText {...{ estimation, category, dimension_key }} />
        </div>
        <Modal open={displayAnalyse} setOpen={setDisplayAnalyse}>
          <div className='h-12' />
          <div className='flex justify-center'>
            <AnalyseInfoCard currentDimension={dimension} />
          </div>
          <div className='h-16' />
        </Modal>
      </>
    )
  }

  return (
    <>
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={() => setDisplayAnalyse(true)}
        style={{ maxWidth: 1024 }}
        className='flex cursor-pointer'
      >
        <div
          className={clsx(
            'rounded-full w-1 h-auto',
            isTouch || isHovered ? 'bg-orange-300' : 'bg-gray-200'
          )}
        />
        <div className='py-3 pl-7 w-full'>
          <div className='flex items-center h-8'>
            <Typo type='h2' underline={isTouch || isHovered}>
              {dimension.property[language]}
            </Typo>
            {(isTouch || isHovered) && <AdjustmentsIcon />}
          </div>
          <div className='h-1' />
          <div className='flex gap-x-8 items-center justify-between'>
            <div className='w-2/3'>
              <EstimationText {...{ estimation, category, dimension_key }} />
            </div>
            <div
              className={clsx(
                'w-1/3 p-4 bg-gray-50 rounded',
                isHovered ? 'bg-orange-50' : 'bg-gray-50'
              )}
            >
              <EstimationState estimation={estimation} />
            </div>
          </div>
        </div>
      </div>
      <Modal open={displayAnalyse} setOpen={setDisplayAnalyse}>
        <div className='h-12' />
        <div className='flex justify-center'>
          <AnalyseInfoCard currentDimension={dimension} />
        </div>
        <div className='h-16' />
      </Modal>
    </>
  )
}

OverviewItem.propTypes = {
  dimension: PropTypes.object.isRequired
}

export default OverviewItem
